"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _router = require("@reach/router");

var _antd = require("antd");

var _Profile = _interopRequireDefault(require("../../pages/Profile"));

var _Dashboard = _interopRequireDefault(require("../../pages/Dashboard"));

var _Media = _interopRequireDefault(require("../../pages/Media"));

var _PostType = _interopRequireDefault(require("../../pages/PostType"));

var _Settings = _interopRequireDefault(require("../../pages/Settings"));

var _Taxonomy = _interopRequireDefault(require("../../pages/Taxonomy"));

var _Users = _interopRequireDefault(require("../../pages/Users"));

var _AdminEditor = _interopRequireDefault(require("../editor/AdminEditor"));

var _theme = require("../../theme");

var _redux = require("../../redux");

var _routes = require("../../routes"); // import components


var AdminRouter = function AdminRouter(props) {
  var _authUser$capabilitie, _authUser$capabilitie2;

  var fields = props.fields;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      dialog = _ref.ui.dialog,
      authUser = _ref.auth.user;

  var dispatch = (0, _redux.useAppDispatch)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_theme.CmsStyles, null), /*#__PURE__*/_react.default.createElement(_router.Router, null, /*#__PURE__*/_react.default.createElement(_Profile.default, {
    path: "".concat(_routes.ROUTE_APP).concat(_routes.ROUTE_PROFILE),
    fields: fields
  }), /*#__PURE__*/_react.default.createElement(_Dashboard.default, {
    path: "".concat(_routes.ROUTE_APP),
    fields: fields
  }), /*#__PURE__*/_react.default.createElement(_Media.default, {
    path: "".concat(_routes.ROUTE_APP).concat(_routes.ROUTE_MEDIA),
    fields: fields
  }), /*#__PURE__*/_react.default.createElement(_PostType.default, {
    path: "".concat(_routes.ROUTE_APP).concat(_routes.ROUTE_POST_TYPE, "/:postTypeID"),
    fields: fields
  }), /*#__PURE__*/_react.default.createElement(_Taxonomy.default, {
    path: "".concat(_routes.ROUTE_APP).concat(_routes.ROUTE_TAXONOMY, "/:taxonomyID"),
    fields: fields
  }), (authUser === null || authUser === void 0 ? void 0 : (_authUser$capabilitie = authUser.capabilities) === null || _authUser$capabilitie === void 0 ? void 0 : _authUser$capabilitie.manage_options) && /*#__PURE__*/_react.default.createElement(_Settings.default, {
    path: "".concat(_routes.ROUTE_APP).concat(_routes.ROUTE_SETTINGS_GENERAL),
    fields: fields
  }), (authUser === null || authUser === void 0 ? void 0 : (_authUser$capabilitie2 = authUser.capabilities) === null || _authUser$capabilitie2 === void 0 ? void 0 : _authUser$capabilitie2.list_users) && /*#__PURE__*/_react.default.createElement(_Users.default, {
    path: "".concat(_routes.ROUTE_APP).concat(_routes.ROUTE_USERS),
    fields: fields
  }), /*#__PURE__*/_react.default.createElement(_AdminEditor.default, (0, _extends2.default)({
    path: '*'
  }, props, {
    fields: fields
  }))), dialog.open && /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    transitionName: "none",
    maskTransitionName: "none",
    title: dialog.title,
    visible: dialog.open,
    onCancel: function onCancel() {
      return dispatch(_redux.uiActions.hideDialog());
    },
    destroyOnClose: true,
    children: dialog.component,
    width: dialog.width,
    footer: null
  }));
};

var _default = AdminRouter;
exports.default = _default;